import { render, staticRenderFns } from "./MobileOptions.vue?vue&type=template&id=327fd11e&scoped=true&"
import script from "./MobileOptions.vue?vue&type=script&lang=js&"
export * from "./MobileOptions.vue?vue&type=script&lang=js&"
import style0 from "./MobileOptions.vue?vue&type=style&index=0&id=327fd11e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "327fd11e",
  null
  
)

export default component.exports